export const fuzzyMatchScore = (text: string, query: string): number => {
  if (!query) return 0;
  const t = text.toLowerCase();
  const q = query.toLowerCase();
  if (t === q) return 1;
  if (t.startsWith(q)) return 0.85;
  const idx = t.indexOf(q);
  if (idx >= 0) return 0.55 - Math.min(0.2, idx / t.length * 0.2);

  let ti = 0;
  let matched = 0;
  let consecutive = 0;
  let maxConsecutive = 0;
  for (let qi = 0; qi < q.length; qi++) {
    while (ti < t.length && t[ti] !== q[qi]) ti++;
    if (ti >= t.length) return 0;
    ti++;
    matched++;
    consecutive++;
    maxConsecutive = Math.max(maxConsecutive, consecutive);
    if (ti < t.length && t[ti] !== q[qi + 1]) consecutive = 0;
  }
  if (matched !== q.length) return 0;
  return 0.1 + Math.min(0.3, maxConsecutive / q.length * 0.3);
};

export interface FuzzyResult<T> {
  item: T;
  score: number;
}

export const fuzzyFilter = <T>(
  items: readonly T[],
  query: string,
  getText: (item: T) => string
): FuzzyResult<T>[] => {
  const scored = items
    .map((item) => ({ item, score: fuzzyMatchScore(getText(item), query) }))
    .filter((r) => r.score > 0);
  scored.sort((a, b) => b.score - a.score);
  return scored;
};
